import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable, Type } from '@angular/core';
import {DipRegistrationConfirmationModalComponent} from '../../../modals/dip-registration-confirmation-modal/dip-registration-confirmation-modal.component';
import {TranslateService} from '@ngx-translate/core';
import { DipRegistrationService } from '../../../dip-registration.service';
import { map } from 'rxjs/operators';
import { ModalService } from '../../../shared/components/modal/modal.service';



@Injectable()
export class DipRegistrationCloseGuardService  {
  constructor(
    private dipseModalService: ModalService,
    private router: Router,
    private translateService: TranslateService,
    private readonly dipRegistrationService: DipRegistrationService
  ) {
  }

  async canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): Promise<boolean> {
    if (this.router.getCurrentNavigation().trigger === 'popstate' || (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.needConfirmation)) {
      const title = await this.translateService.get('DIPRSRegistration.confirmation.modal.title').toPromise();
      const focusBtn = this.router.getCurrentNavigation()?.extras?.state?.button;
      if (focusBtn) {
        this.router.getCurrentNavigation().extras.state.button = null;
      }
      return this.dipseModalService.create<DipRegistrationConfirmationModalComponent, boolean>(
        DipRegistrationConfirmationModalComponent,
        (containerInstance, instance) => {
          containerInstance.modalDialogClass = 'modal-md';
          containerInstance.modalTitle = title;
          containerInstance.closeLabel = this.translateService.instant('DIPRSRegistration.modal.close.label');
          instance.close.subscribe(containerInstance.destroy);
          instance.continue.subscribe(async () => {
            await this.dipRegistrationService.resetAndReload();
          });
        },
        focusBtn
      ).pipe(map(data => !!data))
        .toPromise();
    }
    return true;
  }
}
